import Button from "../components/buttons/Button";
import Constants from "../constants/constants";
import { useContext, useState, useRef } from "react";
import { ModalContext } from "../context/contextProvider";
import { ThemeColorsEnum } from "../constants/enums";
import Services from '../services/services';

const RenderFileContent = ({
  fileContent,
  withButton = false
}) => {

  const { showModal, closeModal, showLastModal } = useContext(ModalContext);
  const [fileUrl, setFileUrl] = useState();
  //const setFileUrl = (value) => {
  //  fileUrl.current = value;
  //};
  const acceptedTypes = Constants.defaultAcceptedFileTypes;

  const showImageModal = (content) => {
    closeModal();
    setTimeout(() => showModal(
      `${fileContent?.fileMetaData?.displayName ?? 
          fileContent?.metaData?.data?.displayName}`,
      content,
      [
        {
          color: ThemeColorsEnum.quaternary,
          title: "Back",
          onClick: () => {setTimeout(() => showLastModal(), 650)}
        },
      ],
      null,
      "lg",
      true,
    ), 650);
  };

  const base64ToBlobUrl = (base64, type) => {
    if (typeof base64 !== "string" || !base64.length) {
      return base64;
    }

    // If it's a data URL, strip the header, keep only the Base64 payload
    const base64Data = base64.startsWith("data:")
      ? base64.split(",")[1] ?? ""
      : base64;

    try {
      const binary = window.atob(base64Data); // browser-safe Base64 decode
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);

      const blob = new Blob([bytes], { type: type });
      return URL.createObjectURL(blob);
    } catch (err) {
      throw new Error("Invalid Base64 string.");
    }
  };

  const viewFileModal = (fileUrl) => {
    closeModal();

    const blobUrl = base64ToBlobUrl(fileUrl, "application/pdf");

    setTimeout(() => { 
      showModal(`${fileContent?.fileMetaData?.displayName
        ?? fileContent?.metaData?.data?.displayName}`,
      <div>
        <object
          data={blobUrl}
          type='application/pdf'
          width='750px'
          height='1200px'
          aria-label='PDF Document'
        />
      </div>,
      [
        {
          color: ThemeColorsEnum.quaternary,
          title: "Back",
          onClick: () => {setTimeout(() => showLastModal(), 650)}
        },
      ],
      null,
      "lg",
      true
    );}, 650);
  }
  if (!fileContent) {
    return (<p> No file found </p>);
  }
  const { fileData, metaData, extension } = fileContent;

  // An array of every accepted extension having the "image" type (e.g. [ "png", "jpg", "jpeg" ])
  const acceptedImageTypes = acceptedTypes.filter(x => x.type === "image").map(x => x.ext);
  // An array of every accepted extension having the "application" type (e.g. [ "pdf" ])
  const acceptedApplicationTypes = acceptedTypes.filter(x => x.type === "application").map(x => x.ext);
  
  try {
    //Stream file
    // // Rendering for "image" file types (e.g. "image/png")
    if (acceptedImageTypes.includes(extension)) {

      //const base64Img = Base64.fromUint8Array(fileData);
      //const img = `data:image/${extension};base64,${base64Img.substring(base64Img.indexOf(',') + 1)}`;
      const isBlob = input => 'Blob' in window && input instanceof Blob;
      var base64Img = '';
      if (!isBlob(fileData)) {
        base64Img = URL.createObjectURL(fileData?.data);
      }
      else {
        base64Img = URL.createObjectURL(fileData);
      }
      return (
        withButton ? (
          <div>
            <Button title="View file" onClick={() => {
              showImageModal(<div>
                <img style={
                  {
                    maxWidth: '95%',
                    margin: '20'
                  }
                }
                  src={base64Img} />

              </div>
              )
            }} />
          </div>
        ) :
          (
            <div>
              <img
                onClick={() => {
                  showImageModal(<div>
                    <img style={
                      {
                        maxWidth: '95%',
                        margin: '20',
                      }
                    }
                      src={base64Img} />

                  </div>
                  )
                }}
                style={
                  {
                    maxWidth: '20%',
                    margin: '20',
                    cursor: 'pointer'
                  }
                }
                src={base64Img} />

            </div>
          )
      );
    }
    // Rendering for "application" file types (e.g. "application/pdf")
    else if (acceptedApplicationTypes.includes(extension)) {
      var reader = new FileReader();
      const isBlob = input => 'Blob' in window && input instanceof Blob;
      if (extension === "pdf") {
        if (!isBlob(fileData)) {
          reader.readAsDataURL(fileData?.data);
          reader.onloadend = function() {
            setFileUrl(`data:application/pdf;base64,${reader.result.substring(reader.result.indexOf(',') + 1)}`);
          };
        }
        else {
          reader.readAsDataURL(fileData);
          reader.onloadend = function() {
            setFileUrl(`data:application/pdf;base64,${reader.result.substring(reader.result.indexOf(',') + 1)}`);
          };
        }
  
        return (
          withButton ? (
            <div>
              <Button
                title="View Pdf"
                onClick={() => {
                  viewFileModal(fileUrl);

                  Services.api.users.trackFeature({
                    usageType: "PDF Viewed"
                  });
                }}
              />
            </div>
          ) : (
            <div>
              <object
                data={base64ToBlobUrl(fileUrl, "application/pdf")}
                type="application/pdf"
                width="750px"
                height="1200px"
                aria-label="PDF Document"
              />
            </div>
          )
        );
      }
    }
  }
  catch (err) {
    return Services.utility.toast("Problem: " + err);
  }

  return (<p> No file found </p>);
};

export default RenderFileContent;
